// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {getAuth} from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "store-for-avatar.firebaseapp.com",
  projectId: "store-for-avatar",
  storageBucket: "store-for-avatar.appspot.com",
  messagingSenderId: "1010564798906",
  appId: "1:1010564798906:web:3e7573b9487c0f55df6583",
  measurementId: "G-RWFYEYVG0F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth =  getAuth(app);
